import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setCardContent } from "services/api/communication";
import { EditTemplate } from "../EditTemplate/EditTemplate";
import { SendEmail } from "../SendEmail/SendEmail";
import MyTemplateCreateAutomation from "./MyTemplateCreateAutomation/MyTemplateCreateAutomation";
import { Wrapper } from "./Theme";

export const MyTemplate = ({
  formik,
  cardContent,
  onNext,
  activeStep,
  onBack,
  setActiveStep,
  setCardName,
  eventTypes,
}) => {
  const [viewTemplate, setViewTemplate] = useState(false);
  const dispatch=useDispatch()
  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <MyTemplateCreateAutomation
            formik={formik}
            cardContent={cardContent}
            onNext={onNext}
            activeStep={activeStep}
            setViewTemplate={setViewTemplate}
            viewTemplate={viewTemplate}
            setActiveStep={setActiveStep}
            onBack={()=>dispatch(setCardContent("Create Campaign"))}
            eventTypes={eventTypes}

           
          />
        );
      case 1:
        return (
          <EditTemplate
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            setViewTemplate={setViewTemplate}
            viewTemplate={viewTemplate}
          />
        );
      case 2:
        return (
          <SendEmail
            formik={formik}
            onNext={onNext}
            onBack={onBack}
            isMultiple={false}
            setActiveStep={setActiveStep}
            setViewTemplate={setViewTemplate}
            step={1}
            setCardName={setCardName}
          />
        );

      default:
        return;
    }
  };

  return <Wrapper>{renderContent()}</Wrapper>;
};
